import React, { Component } from 'react';
import { connect } from "react-redux";
import actions from 'store/actions';
import { BusinessAreaApiKeyHistoryList, LoadingOverlay, FullHeightContainerLayout } from "components";
import { showError } from 'common/ToastNotifications';
import { withRouter } from "react-router";
import { Typography, Empty } from 'antd';

const { Title, Text } = Typography;

class EventBusinessAreaApiKeys extends Component {

    constructor(props) {
        super(props);
        this.state = {
            fetchingData: true
        }
    }

    componentWillMount() {
        if (this.props.itemOperation && this.props.eventType === "BATCH_PROCESSING") {
            let headerText = "";
            let headerDetails = `(Business Area: ${this.props.businessAreaName})`
            switch (this.props.itemOperation) {
                case "INSERT":
                    headerText = "Added business area API keys"
                    break;
                case "DELETE":
                    headerText = "Deleted business area API keys"
                    break;
                case "UPDATE":
                    headerText = "Updated business area API keys"
                    break;
                default:
                    break;
            }
            this.setState({
                headerText,
                headerDetails
            });
            this.setState({
                busy: true,
                busyMessage: "Getting business area API keys...",
            });
            this.props.getEventBusinessAreaApiKeys(this.props.eventId, this.props.itemOperation, null);
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.onGetEventBusinessAreaApiKeysResultUpdate(prevProps);
    }

    onGetEventBusinessAreaApiKeysResultUpdate = (prevProps) => {
        if (this.props.getEventBusinessAreaApiKeysResult && this.props.getEventBusinessAreaApiKeysResult !== prevProps.getEventBusinessAreaApiKeysResult) {
            if (!this.props.getEventBusinessAreaApiKeysResult.success) {
                if (this.props.getEventBusinessAreaApiKeysResult.code === "PERMISSION_DENIED") {
                    this.setState({
                        permissionDenied: true
                    });
                }
                else {
                    showError("Unable to get business area API keys at this moment.");
                }
            }
            this.setState({
                busy: false,
                busyMessage: "",
                fetchingData: false
            });
        }
    }

    isBusy = () => {
        let isBusy = (this.state.busy || this.state.fetchingData);
        return isBusy;
    }

    render() {
        return (
            <>
                {
                    this.isBusy()
                        ?
                        <LoadingOverlay
                            busy={true}
                            spinner
                            message={this.state.busyMessage || "Please wait..."}>
                        </LoadingOverlay>
                        :
                        <></>
                }
                {
                    !this.state.fetchingData
                        ?
                        <FullHeightContainerLayout
                            showHeader={true}
                            showFooter={false}
                            header={<Title level={5}><Text>Event Batch - </Text><Text>{this.state.headerText}</Text><Text> - </Text><Text type="secondary">{this.state.headerDetails}</Text></Title>}
                            content={this.props.apiKeysResult ?
                                <BusinessAreaApiKeyHistoryList
                                    businessAreaApiKeyRevisions={this.props.apiKeysResult.Items}>
                                </BusinessAreaApiKeyHistoryList>
                                :
                                <Empty></Empty>}>
                        </FullHeightContainerLayout>
                        :
                        <></>
                }

            </>);
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        getEventBusinessAreaApiKeysResult: state.eventBusinessAreaApiKeys.getEventBusinessAreaApiKeysResult,
        apiKeysResult: state.eventBusinessAreaApiKeys.apiKeysResult
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getEventBusinessAreaApiKeys: (eventId, itemOperation, pageKey) => dispatch(actions.getEventBusinessAreaApiKeysRequest(eventId, itemOperation, pageKey))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EventBusinessAreaApiKeys));
